<script setup lang="ts">
</script>
<template>
  <router-view />
  <notifications position="top right" />
</template>
<style scoped>
/* @font-face {
  font-family: 'DotGothic16-Regular';
  src: url('/public/font/DotGothic16/DotGothic16-Regular.ttf');
} */
/**format('truetype'); */
/* * {
  font-family: 'DotGothic16-Regular', serif;
} */
</style>